import React from 'react';
import './DeleteConfirm.css';

const DeleteConfirm = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  entityType, 
  entityLabel, 
  impactWarnings = [], 
  isDeleting = false 
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    if (!isDeleting) {
      onClose();
    }
  };

  return (
    <div className="delete-confirm-overlay">
      <div className="delete-confirm-modal">
        <div className="delete-confirm-header">
          <h3>Confirm deletion</h3>
        </div>
        
        <div className="delete-confirm-body">
          <p>
            You are about to delete this {entityType}: <strong>{entityLabel}</strong>
          </p>
          <p className="permanent-warning">This action cannot be undone.</p>
          
          {impactWarnings.length > 0 && (
            <div className="impact-warnings">
              {impactWarnings.map((warning, index) => (
                <p key={index} className="impact-warning">
                  ⚠️ {warning}
                </p>
              ))}
            </div>
          )}
        </div>
        
        <div className="delete-confirm-footer">
          <button
            className="btn-cancel"
            onClick={handleCancel}
            disabled={isDeleting}
          >
            No, Cancel
          </button>
          <button
            className="btn-delete"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Yes, Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirm;
